import type { ProductInformation } from '@dealerportal/common';
import { useFavouriteProducts } from '@dealerportal/react-helpers';
import { toast } from 'react-toastify';

/**
 * Favourite state and toggle for a product, for the heart button overlaid on
 * the hero media. Shows the "added" toast only when favouriting, not when
 * removing.
 */
export const useFavouriteToggle = (productInfo: ProductInformation) => {
  const favouriteProductsCtx = useFavouriteProducts();
  const isFavourite = Boolean(
    favouriteProductsCtx?.find?.({ UPID: productInfo?.UPID ?? '' })
  );

  const toggleFavourite = () => {
    if (!favouriteProductsCtx?.addRemoveProductsFromFav) return;
    const wasFavourite = isFavourite;
    favouriteProductsCtx.addRemoveProductsFromFav(productInfo);
    if (!wasFavourite) {
      toast('Product added to favorites');
    }
  };

  return { isFavourite, toggleFavourite };
};
